import React, { useState, useEffect } from "react";
import "./agencies.css";
import { useNavigate } from "react-router-dom";
import BackMenu from "../../assets/icons/Arrow-Left-Back-Menu.png";
import { cal_3_weight } from "../../utils/calculation";
import DashboardPage from "../dashboard";

/* Icon cars*/
import MotoBike from "../../assets/images/motor-bike.png";
import Car from "../../assets/images/car.png";
import Taxi from "../../assets/images/taxi.png";
import TukTuk from "../../assets/images/tuk-tuk.png";
import PikupTruck from "../../assets/images/pikup-truck.png";
import Van from "../../assets/images/van.png";
import Bus from "../../assets/images/bus.png";

const MenuThree = ({ data }) => {
  const navigate = useNavigate();
  const roadModes = Object.values(data?.emission?.road_modes || {});

  const [passenger_year, set_passenger_year] = useState("");
  const [km_year, set_km_year] = useState("");
  const [percenct_motorcycle, set_percenct_motorcycle] = useState("");
  const [percenct_passenger, set_percenct_passenger] = useState("");
  const [percenct_taxi, set_percenct_taxi] = useState("");
  const [percenct_tuktuk, set_percenct_tuktuk] = useState("");
  const [percenct_pickuptruck, set_percenct_pickuptruck] = useState("");
  const [percenct_van, set_percenct_van] = useState("");
  const [percenct_bus, set_percenct_bus] = useState("");
  const [electrictrain_MWh_YEAR, set_electrictrain_MWh_YEAR] = useState("");

  const [emissionResults3, setEmissionResults3] = useState({
    road: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    train: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    reduce: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
  });

  // Road
  const formatRoadTc02 = parseFloat(
    emissionResults3.road.tCO2.toFixed(2)
  ).toLocaleString();
  const formatRoadKgPM2 = parseFloat(
    emissionResults3.road.kgPM2.toFixed(2)
  ).toLocaleString();
  const formatRoadKgNOx = parseFloat(
    emissionResults3.road.kgNOx.toFixed(2)
  ).toLocaleString();
  const formatRoadKgCO = parseFloat(
    emissionResults3.road.kgCO.toFixed(2)
  ).toLocaleString();

  // Train
  const formatTrainTc02 = parseFloat(
    emissionResults3.train.tCO2.toFixed(2)
  ).toLocaleString();
  const formatTrainKgPM2 = parseFloat(
    emissionResults3.train.kgPM2.toFixed(2)
  ).toLocaleString();
  const formatTrainKgNOx = parseFloat(
    emissionResults3.train.kgNOx.toFixed(2)
  ).toLocaleString();
  const formatTrainKgCO = parseFloat(
    emissionResults3.train.kgCO.toFixed(2)
  ).toLocaleString();

  // Reduce
  const formatReduceTc02 = parseFloat(
    emissionResults3.reduce.tCO2.toFixed(2)
  ).toLocaleString();
  const formatReduceKgPM2 = parseFloat(
    emissionResults3.reduce.kgPM2.toFixed(2)
  ).toLocaleString();
  const formatReduceKgNOx = parseFloat(
    emissionResults3.reduce.kgNOx.toFixed(2)
  ).toLocaleString();
  const formatReduceKgCO = parseFloat(
    emissionResults3.reduce.kgCO.toFixed(2)
  ).toLocaleString();

  const handleSetPassengerYear = (event) =>
    set_passenger_year(event.target.value);
  const handleSetMotorcycle = (event) =>
    set_percenct_motorcycle(event.target.value);
  const handleSetPassenger = (event) =>
    set_percenct_passenger(event.target.value);
  const handleSetTaxi = (event) => set_percenct_taxi(event.target.value);
  const handleSetTuktuk = (event) => set_percenct_tuktuk(event.target.value);
  const handleSetPickuptruck = (event) =>
    set_percenct_pickuptruck(event.target.value);
  const handleSetVan = (event) => set_percenct_van(event.target.value);
  const handleSetBus = (event) => set_percenct_bus(event.target.value);
  const handleSetKmYear = (event) => set_km_year(event.target.value);
  const handleSetElectricYear = (event) =>
    set_electrictrain_MWh_YEAR(event.target.value);

  useEffect(() => {
    const handler = setTimeout(() => {
      const isReadyForCalculation =
        data?.emission?.vehicle_types &&
        data?.emission?.electrictrain &&
        (parseFloat(passenger_year) > 0 ||
          parseFloat(km_year) > 0 ||
          parseFloat(electrictrain_MWh_YEAR) > 0 ||
          parseFloat(percenct_motorcycle) > 0 ||
          parseFloat(percenct_passenger) > 0 ||
          parseFloat(percenct_taxi) > 0 ||
          parseFloat(percenct_tuktuk) > 0 ||
          parseFloat(percenct_pickuptruck) > 0 ||
          parseFloat(percenct_van) > 0 ||
          parseFloat(percenct_bus) > 0);

      if (isReadyForCalculation) {
        const passenger_year_val = parseFloat(passenger_year) || 0;
        const km_year_val = parseFloat(km_year) || 0;
        const percent_motorcycle_val = parseFloat(percenct_motorcycle) || 0;
        const percent_passenger_val = parseFloat(percenct_passenger) || 0;
        const percent_taxi_val = parseFloat(percenct_taxi) || 0;
        const percent_tuktuk_val = parseFloat(percenct_tuktuk) || 0;
        const percent_pickuptruck_val = parseFloat(percenct_pickuptruck) || 0;
        const percent_van_val = parseFloat(percenct_van) || 0;
        const percent_bus_val = parseFloat(percenct_bus) || 0;
        const electrictrain_MWh_val = parseFloat(electrictrain_MWh_YEAR) || 0;

        console.log("--- ค่าที่กรอกจากผู้ใช้ (ก่อนส่งไป cal_3_weight) ---");
        console.log(
          "ปริมาณผู้โดยสารต่อปี (passenger_year):",
          passenger_year_val
        );
        console.log("ระยะทางเฉลี่ยต่อปี (km_year):", km_year_val);
        console.log("สัดส่วนรถจักรยานยนต์ (%):", percent_motorcycle_val);
        console.log("สัดส่วนรถยนต์ส่วนบุคคล (%):", percent_passenger_val);
        console.log("สัดส่วนรถแท็กซี่ (%):", percent_taxi_val);
        console.log("สัดส่วนรถสามล้อเครื่อง (%):", percent_tuktuk_val);
        console.log("สัดส่วนรถสองแถว (%):", percent_pickuptruck_val);
        console.log("สัดส่วนรถตู้ (%):", percent_van_val);
        console.log("สัดส่วนรถโดยสารประจำทาง (%):", percent_bus_val);
        console.log(
          "ปริมาณการใช้ไฟฟ้าของรถไฟฟ้าต่อปี (MWh):",
          electrictrain_MWh_val
        );
        console.log("-----------------------------------------------------");

        const calculatedEmissions = cal_3_weight(
          data,
          passenger_year_val,
          km_year_val,
          percent_motorcycle_val,
          percent_passenger_val,
          percent_taxi_val,
          percent_tuktuk_val,
          percent_pickuptruck_val,
          percent_van_val,
          percent_bus_val,
          electrictrain_MWh_val
        );

        setEmissionResults3(calculatedEmissions);

        console.log("--- ค่าที่ได้รับจากฟังก์ชัน cal_3_weight ---");
        console.log("ผลลัพธ์การปล่อยมลพิษ:", calculatedEmissions);
        console.log("---------------------------------------------");
      } else {
        setEmissionResults3({
          road: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
          train: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
          reduce: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
        });
      }
    }, 3000);

    return () => clearTimeout(handler);
  }, [
    data,
    passenger_year,
    km_year,
    percenct_motorcycle,
    percenct_passenger,
    percenct_taxi,
    percenct_tuktuk,
    percenct_pickuptruck,
    percenct_van,
    percenct_bus,
    electrictrain_MWh_YEAR,
  ]);

  return (
    <div className="agencies-modal">
      <div className="agencies">
        <div className="all-3">
          <div className="box-name-p3">
            <div className="text-title">เส้นทางและรูปแบบการเดินทาง</div>
          </div>

          <div className="agen-full-bg-green">
            <div className="tran-green">
              <div className="form-input-agencies">
                <div className="text-head">
                  ปริมาณผู้โดยสารที่ใช้บริการรถไฟฟ้าขนส่งมวลชนต่อปี
                </div>
                <input
                  placeholder=""
                  className="input-three"
                  value={passenger_year}
                  onChange={handleSetPassengerYear}
                  type="number"
                />
                <div className="b3">คนต่อปี</div>
              </div>

              <div className="form-input-2new">
                {/* Inputs for each vehicle type */}
                <div className="shoose-passenger">
                  <div className="isbox1">สัดส่วนการเดินทางรูปแบบ</div>
                  <div className="isbox2">
                    <img src={MotoBike} width={45} alt="" />
                    <div>รถจักรยานยนต์</div>
                  </div>
                  <div className="isbox3">
                    <input
                      type="number"
                      onChange={handleSetMotorcycle}
                      min={0}
                      max={100}
                      // defaultValue={0}
                      placeholder="0-100 "
                    />
                    <div>%</div>
                  </div>
                </div>

                <div className="shoose-passenger">
                  <div className="isbox1"></div>
                  <div className="isbox2">
                    <img src={Car} width={45} alt="" />
                    <div>รถยนต์นั่งส่วนบุคคล</div>
                  </div>
                  <div className="isbox3">
                    <input
                      type="number"
                      onChange={handleSetPassenger}
                      min={0}
                      max={100}
                      // defaultValue={0}
                      placeholder="0-100 "
                    />
                    <div>%</div>
                  </div>
                </div>

                <div className="shoose-passenger">
                  <div className="isbox1"></div>
                  <div className="isbox2">
                    <img src={Taxi} width={45} alt="" />
                    <div>รถแท๊กซี่</div>
                  </div>
                  <div className="isbox3">
                    <input
                      type="number"
                      onChange={handleSetTaxi}
                      min={0}
                      max={100}
                      // defaultValue={0}
                      placeholder="0-100 "
                    />
                    <div>%</div>
                  </div>
                </div>

                <div className="shoose-passenger">
                  <div className="isbox1"></div>
                  <div className="isbox2">
                    <img src={TukTuk} width={45} alt="" />
                    <div>รถสามล้อเครื่อง</div>
                  </div>
                  <div className="isbox3">
                    <input
                      type="number"
                      onChange={handleSetTuktuk}
                      min={0}
                      max={100}
                      // defaultValue={0}
                      placeholder="0-100 "
                    />
                    <div>%</div>
                  </div>
                </div>

                <div className="shoose-passenger">
                  <div className="isbox1"></div>
                  <div className="isbox2">
                    <img src={PikupTruck} width={45} alt="" />
                    <div>รถสองแถว</div>
                  </div>
                  <div className="isbox3">
                    <input
                      type="number"
                      onChange={handleSetPickuptruck}
                      min={0}
                      max={100}
                      // defaultValue={0}
                      placeholder="0-100 "
                    />
                    <div>%</div>
                  </div>
                </div>

                <div className="shoose-passenger">
                  <div className="isbox1"></div>
                  <div className="isbox2">
                    <img src={Van} width={45} alt="" />
                    <div>รถตู้</div>
                  </div>
                  <div className="isbox3">
                    <input
                      type="number"
                      onChange={handleSetVan}
                      min={0}
                      max={100}
                      // defaultValue={0}
                      placeholder="0-100 "
                    />
                    <div>%</div>
                  </div>
                </div>

                <div className="shoose-passenger">
                  <div className="isbox1"></div>
                  <div className="isbox2">
                    <img src={Bus} width={45} alt="" />
                    <div>รถโดยสารประจำทาง {`(รถเมล์)`}</div>
                  </div>
                  <div className="isbox3">
                    <input
                      type="number"
                      onChange={handleSetBus}
                      min={0}
                      max={100}
                      // defaultValue={0}
                      placeholder="0-100 "
                    />
                    <div>%</div>
                  </div>
                </div>
              </div>

              <div className="form-input-agencies">
                <div className="text-head">
                  ปริมาณการใช้ไฟฟ้าของรถไฟฟ้าต่อปี
                </div>
                <input
                  placeholder=""
                  className="input-three"
                  value={electrictrain_MWh_YEAR}
                  onChange={handleSetElectricYear}
                  type="number"
                />
                <div className="b3">MWh/ปี</div>
              </div>

              <div className="form-input-agencies">
                <div className="text-head">
                  ระยะทางเฉลี่ยที่ผู้โดยสารเดินทาง
                </div>
                <input
                  placeholder=""
                  className="input-three"
                  value={km_year}
                  onChange={handleSetKmYear}
                  type="number"
                />
                <div className="b3">km</div>
              </div>
            </div>

            <div className="remark-b3">
              {/* หมายเหตุ: *กำหนดให้เชื้อเพลิงที่ใช้เป็นดีเซล */}
            </div>
          </div>

          <div className="box-name-p3">
            <div className="text-title">
              ก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลง
            </div>
          </div>

          <div className="table-agencies">
            <div className="group-name-table-1">
              <span className="name-table-1">Baseline Emission</span>
              <span className="name-table-1-output">{formatRoadTc02}</span>
              <span className="name-table-1-unit">
                {` `} t{` `}CO <sub>2</sub>e
              </span>
            </div>
            <div className="group-name-table-1">
              <span className="name-table-1">Project Emission</span>
              <span className="name-table-1-output">{formatTrainTc02}</span>
              <span className="name-table-1-unit">
                {` `} t{` `}CO <sub>2</sub>e
              </span>
            </div>
            <div className="group-name-table-1">
              <span className="name-table-1">ปริมาณก๊าซเรือนกระจกที่ลดลง</span>
              {/* <span className="name-table-1">
                ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลง
              </span> */}
              <span className="name-table-1-output">{formatReduceTc02}</span>
              <span className="name-table-1-unit">
                {/* t CO <sub>2</sub>e */} {` `} t{` `}CO <sub>2</sub>e
              </span>
            </div>

            <div className="name-table-1"></div>
            <div className="remark-b3-22">
              <div className="">
                หมายเหตุ: หน่วย CO<sub>2</sub> คือ
                <span style={{ color: "#2ecc71" }}>
                  {" "}
                  {` `} t{` `}CO<sub>2</sub>e
                </span>
              </div>
            </div>

          </div>
          
        </div>
      </div>
    </div>
  );
};

export default MenuThree;
